import { GetSessionSharingInfoInput, GetSessionSharingInfoOutput } from '@creative-kit/shared';
import { fn } from 'firebase-modules';
import { FirebaseFunction } from './utils';

export const getSessionSharingInfo: FirebaseFunction<
  GetSessionSharingInfoInput,
  GetSessionSharingInfoOutput
> = fn.httpsCallable('getSessionSharingInfo');
